/** @jsx h */

import { h } from 'preact';

import { assertUnreachable } from '../../../../lib';
import {
    ConsentPopupButton as Button, ConsentPopupColumn as Column, ConsentPopupCouponCode as CouponCode,
    ConsentPopupEmailField as EmailField, ConsentPopupImage as PopupImage, ConsentPopupLogo as Logo,
    ConsentPopupPage as Page, ConsentPopupPhoneField as PhoneField, ConsentPopupQuizComponent as Quiz,
    ConsentPopupSpinner as Spinner, ConsentPopupTerms as Terms, ConsentPopupText as TextContent
} from '../../components';

import type { PopupTemplatePage, PopupTemplateStackElement } from '@onetext/api';
import { ELEMENT_TYPE } from '@onetext/api';

export type TemplatePageProps = {
    page : PopupTemplatePage,
};

export const TemplatePage = ({ page } : TemplatePageProps) : JSX.Element => {

    const renderPageElements = (element : PopupTemplateStackElement) : JSX.Element => {
        switch (element.type) {
            case ELEMENT_TYPE.BUTTON:
                return (
                    <Button
                        overrideStyles={ element.style }
                        closePopup={ element.closePopup }
                        level={ element.level }
                        size={ element.size }
                    >
                        { element.content }
                    </Button>
                );

            case ELEMENT_TYPE.TEXT:
                return (
                    <TextContent
                        content={ element.content }
                        overrideStyles={ element.style }
                    />
                );

            case ELEMENT_TYPE.COUPON_CODE:
                return (
                    <CouponCode
                        content={ element.content }
                        overrideStyles={ element.style }
                    />
                );

            case ELEMENT_TYPE.EMAIL_FIELD:
                return <EmailField overrideStyles={ element.style } />;

            case ELEMENT_TYPE.PHONE_FIELD:
                return <PhoneField overrideStyles={ element.style } />;

            case ELEMENT_TYPE.TERMS:
                return (
                    <Terms
                        overrideStyles={ element.style }
                    />
                );

            case ELEMENT_TYPE.LOGO:
                return <Logo overrideStyles={ element.style } />;

            case ELEMENT_TYPE.IMAGE:
                return (
                    <PopupImage element={ element } />
                );
            case ELEMENT_TYPE.QUIZ:
                return (
                    <Quiz element={ element } />
                );

            case ELEMENT_TYPE.SPINNER:
                return (
                    <Spinner
                        overrideStyles={ element.style }
                        animation={ element.animation }
                    />
                );

            default:
                throw assertUnreachable(element);
        }
    };

    return (
        <Page
            overrideStyles={ page.style }
            openKeyboardOnSubmit>
            {
                page.stacks.map((stack) => {
                    return (
                        <Column overrideStyles={ stack.style }>
                            { stack.elements.map(renderPageElements) }
                        </Column>
                    );

                })
            }
        </Page>
    );
};
